export default __webpack_public_path__ + "static/media/Untitled_Artwork 14.997fc8e3.png";